export const FeatureFlag = {
  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/web-add-punch-to-drawing/targeting LaunchDarkly}
   */
  AddPunchToDrawing: 'web-add-punch-to-drawing',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/web-add-rfi-to-drawing/targeting LaunchDarkly}
   */
  AddRfiToDrawing: 'web-add-rfi-to-drawing',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/bug-create-project/targeting LaunchDarkly}
   */
  CanCreateProjectBasedTrials: 'bug-create-project',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/web-dms-integrations-box/targeting LaunchDarkly}
   */
  DmsIntegrationBox: 'web-dms-integrations-box',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/web-dms-integrations-dropbox/targeting LaunchDarkly}
   */
  DmsIntegrationDropbox: 'web-dms-integrations-dropbox',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/web-dms-integrations-egnyte/targeting LaunchDarkly}
   */
  DmsIntegrationEgnyte: 'web-dms-integrations-egnyte',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/web-dms-integrations-google-drive/targeting LaunchDarkly}
   */
  DmsIntegrationGoogleDrive: 'web-dms-integrations-google-drive',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/web-dms-integrations-one-drive/targeting LaunchDarkly}
   */
  DmsIntegrationOneDrive: 'web-dms-integrations-one-drive',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/web-dms-integrations-sharepoint/targeting LaunchDarkly}
   */
  DmsIntegrationSharePoint: 'web-dms-integrations-sharepoint',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/dms-regions/targeting LaunchDarkly}
   */
  DmsRegions: 'dms-regions',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/web-drawing-tiles/targeting LaunchDarkly}
   */
  DrawingTiles: 'web-drawing-tiles',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/web-links/targeting LaunchDarkly}
   */
  EnableLinks: 'web-links',

  /**
   * For BBESS-1381.
   * @see {@link https://jira.bluebeam.com/browse/BBESS-1381 JIRA}
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/BBESS-1381/targeting LaunchDarkly}
   */
  EssentialsDrawingEditor: 'BBESS-1381',

  /**
   * For BBESS-1465.
   * @see {@link https://jira.bluebeam.com/browse/bbess-1465 JIRA}
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/bbess-1465/targeting LaunchDarkly}
   */
  EssentialsDrawingEditorFilter: 'bbess-1465',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/web-essentials-punch-page/targeting LaunchDarkly}
   */
  EssentialsPunchPage: 'web-essentials-punch-page',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/fit-project-to-screen-button/targeting LaunchDarkly}
   */
  FitProjectToScreenButton: 'fit-project-to-screen-button',

  Fullstory: 'web-fullstory',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/god-mode/targeting LaunchDarkly}
   */
  GodMode: 'god-mode',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/gumball-guardians-protoype/targeting LaunchDarkly}
   */
  GumballGuardiansPrototype: 'gumball-guardians-protoype',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/web-import-from-studio/targeting LaunchDarkly}
   */
  ImportFromStudio: 'web-import-from-studio',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/web-trial-banner/targeting LaunchDarkly}
   */
  ShowTrialBanner: 'web-trial-banner',

  /**
   * Intended for the DEV environment, this allows us to fake the license a current user has.
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/license-stub/targeting LaunchDarkly}
   */
  LicenseStub: 'license-stub',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/map-integration/targeting LaunchDarkly}
   */
  MapIntegration: 'map-integration',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/web-map-tiles/targeting LaunchDarkly}
   */
  MapTiles: 'web-map-tiles',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/web-pendo/targeting LaunchDarkly}
   */
  Pendo: 'web-pendo',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/pendo-header-circle/targeting LaunchDarkly}
   */
  PendoHeaderCircle: 'pendo-header-circle',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/project-storage/targeting LaunchDarkly}
   */
  ProjectStorage: 'project-storage',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/web-punch-import-photos-from-dmstargeting LaunchDarkly}
   */
  PunchImportPhotosFromDms: 'web-punch-import-photos-from-dms',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/web-real-time-connection/targeting LaunchDarkly}
   */
  RealtimeConnection: 'web-real-time-connection',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/region-selector-au/targeting LaunchDarkly}
   */
  RegionAU: 'region-selector-au',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/region-selector-de/targeting LaunchDarkly}
   */
  RegionDE: 'region-selector-de',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/ios-region-selector/targeting LaunchDarkly}
   */
  RegionDropdown: 'ios-region-selector',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/region-selector-se/targeting LaunchDarkly}
   */
  RegionSE: 'region-selector-se',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/region-selector-uk/targeting LaunchDarkly}
   */
  RegionUK: 'region-selector-uk',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/region-selector-us/targeting LaunchDarkly}
   */
  RegionUS: 'region-selector-us',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/rfi-forwarding/targeting LaunchDarkly}
   */
  RfiForwarding: 'rfi-forwarding',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/rfi-revisions/targeting LaunchDarkly}
   */
  RfiRevisions: 'rfi-revisions',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/settings-page/targeting LaunchDarkly}
   */
  SettingsPage: 'settings-page',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/web-submittals/targeting LaunchDarkly}
   */
  Submittals: 'web-submittals',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/web-tiling-notification/targeting LaunchDarkly}
   */
  TilingNotification: 'web-tiling-notification',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/use-studio-private-api/targeting LaunchDarkly}
   */
  UseStudioPrivateApi: 'use-studio-private-api',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/user-groups/targeting LaunchDarkly}
   */
  UserGroups: 'user-groups',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/web-viewer-toolbar/targeting LaunchDarkly}
   */
  ViewerToolbar: 'web-viewer-toolbar',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/web-zipped-uploads/targeting LaunchDarkly}
   */
  ZipUploadsEnabled: 'web-zipped-uploads',
  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/use-new-gateway-url-eks/targeting LaunchDarkly}
   */
  UseAlternateURLs: 'use-new-gateway-url-eks',

  /**
   * For BBCLD-6488
   * @see {@link https://jira.bluebeam.com/browse/BBCLD-6488 JIRA}
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/use-account-for-analytics/targeting LaunchDarkly}
   */
  UseAccountForAnalytics: 'use-account-for-analytics',

  /**
   * For BBCLD-7717
   * @see {@link https://jira.bluebeam.com/browse/BBCLD-7717 JIRA}
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/manage-account-integrations/targeting LaunchDarkly}
   */
  ManageAccountIntegrations: 'manage-account-integrations',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/map-2-integration/targeting LaunchDarkly}
   */
  Map2_Integration: 'map-2.0',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/bb-cloud-labs/targeting LaunchDarkly}
   */
  CloudLabs: 'bb-cloud-labs',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/es-fr-translations/targeting LaunchDarkly}
   */
  ESFRTranslations: 'es-fr-translations',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/3D-Drawings/targeting LaunchDarkly}
   */
  ThreeDDrawings: '3D-Drawings',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/connected-drawings/targeting LaunchDarkly}
   */
  ConnectedDrawings: 'connected-drawings',

  /**
   * @see {@link https://app.launchdarkly.com/coyote-cloud/dev/features/bb-cloud-labs-search/targeting LaunchDarkly}
   */
  CloudSearch: 'bb-cloud-labs-search',

  /**
   * @see {@link https://app.launchdarkly.com/projects/coyote-cloud/flags/bb-cloud-documents/targeting LaunchDarkly}
   */
  CloudDocuments: 'bb-cloud-documents',

  /**
   * @see {@link https://app.launchdarkly.com/projects/coyote-cloud/flags/pendo-debugging/targeting LaunchDarkly}
   */
  PendoDebugging: 'Pendo-Debugging',

  /**
   * @see {@link https://app.launchdarkly.com/projects/coyote-cloud/flags/ios-download-landing-page/targeting LaunchDarkly}
   */
  IosDownloadLandingPage: 'ios-download-landing-page',

  /**
   * @see {@link https://app.launchdarkly.com/projects/coyote-cloud/flags/android-download-landing-page/targeting LaunchDarkly}
   */
  AndroidDownloadLandingPage: 'android-download-landing-page',
} as const;

export enum LaunchDarklyContexts {
  User = 'user',
  Organization = 'organization',
  Device = 'ld_device',
  Application = 'ld_application',
}
